<template>
  <vue-scroll>
  <div class="internal-bulletin">
    <div class="page-header">
      <h2>内部通报板</h2>
    </div>

    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title">
          <Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :label-width="80">
            <FormItem label="标题">
              <Input v-model="filterModel.title" placeholder="输入标题关键字" />
            </FormItem>
            <FormItem label="类型">
              <Select v-model="filterModel.type" placeholder="选择类型" style="width:150px">
                <Option value="all">全部</Option>
                <Option value="notice">通知</Option>
                <Option value="warning">警告</Option>
                <Option value="info">信息</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="refresh">查询</Button>
              <Button type="default" @click="resetFilter" style="margin-left:10px">重置</Button>
            </FormItem>
          </Form>
        </div>
      </Panel>
    </Collapse>

    <div class="padding-top-10"></div>

    <Card>
      <p slot="title">
        <Icon type="ios-megaphone" /> 通报列表
      </p>
      <div v-if="data.length === 0" class="no-data">
        <Icon type="ios-folder-open" size="48" />
        <p>暂无通报记录</p>
      </div>
      <Timeline v-else>
        <TimelineItem v-for="(item, idx) in data" :key="idx" :color="getColor(item.type)">
          <div class="bulletin-item">
            <div class="bulletin-header">
              <Tag :color="getTagColor(item.type)">{{getTypeName(item.type)}}</Tag>
              <span class="bulletin-title">{{item.title}}</span>
              <span class="bulletin-date">{{item.createTime}}</span>
            </div>
            <div class="bulletin-content" v-html="item.content"></div>
            <div class="bulletin-footer">
              <span class="bulletin-author">发布人：{{item.author || '系统'}}</span>
              <Button type="text" size="small" @click="viewDetail(item)">查看详情</Button>
            </div>
          </div>
        </TimelineItem>
      </Timeline>
    </Card>

    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'internal-bulletin',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      data: [],
      totalCount: 0,
      currentPageIndex: 1,
      pageSize: 10,
      filterModel: {
        title: null,
        type: 'all'
      },
      // Static demo data for now
      demoData: [
        {
          id: 1,
          title: '关于加强保函审核管理的通知',
          content: '各经办机构请注意，即日起所有新提交保函将实行更加严格的审核标准，请确保提交资料完整准确。',
          type: 'notice',
          author: '管理员',
          createTime: '2026-05-15 10:30:00'
        },
        {
          id: 2,
          title: '系统升级维护通知',
          content: '系统将于本周六进行例行维护，届时部分功能可能暂时无法使用，请提前做好工作安排。',
          type: 'info',
          author: '系统管理员',
          createTime: '2026-05-10 09:00:00'
        },
        {
          id: 3,
          title: '关于某机构违规操作的警告',
          content: '经查实，某机构存在违规操作行为，现予以通报批评。请各机构引以为戒，遵守相关规定。',
          type: 'warning',
          author: '监管部门',
          createTime: '2026-05-08 14:20:00'
        },
        {
          id: 4,
          title: '新功能上线通知',
          content: '电子签发功能已正式上线，符合条件的保函可在审核通过后直接在线签发，无需线下办理。',
          type: 'info',
          author: '技术部',
          createTime: '2026-05-05 16:00:00'
        }
      ]
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.loadData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.loadData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    loadData () {
      // For demo, using static data
      // In production, this would call API
      this.data = this.demoData
      this.totalCount = this.demoData.length
    },
    refresh () {
      this.currentPageIndex = 1
      this.loadData()
    },
    resetFilter () {
      this.filterModel = {
        title: null,
        type: 'all'
      }
      this.refresh()
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    changePageSize (e) {
      this.pageSize = e
    },
    getColor (type) {
      switch (type) {
        case 'warning': return 'red'
        case 'notice': return 'blue'
        case 'info': return 'green'
        default: return 'gray'
      }
    },
    getTagColor (type) {
      switch (type) {
        case 'warning': return 'error'
        case 'notice': return 'primary'
        case 'info': return 'success'
        default: return 'default'
      }
    },
    getTypeName (type) {
      switch (type) {
        case 'warning': return '警告'
        case 'notice': return '通知'
        case 'info': return '信息'
        default: return '其他'
      }
    },
    viewDetail (item) {
      this.$Modal.info({
        title: item.title,
        content: `<p>${item.content}</p><p style="margin-top:10px;color:#999">发布人：${item.author} &nbsp;&nbsp; 发布时间：${item.createTime}</p>`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.internal-bulletin {
  .page-header {
    margin-bottom: 20px;
    h2 {
      color: @primaryColor;
    }
  }
  .table-tools-panel {
    .table-tools-panel-title {
      font-weight: bold;
      display: inline-block;
    }
    .table-tools-panel-title-icon {
      margin-right: 20px;
    }
  }
  .pager {
    margin: 20px 0;
  }
  .no-data {
    text-align: center;
    padding: 40px 0;
    color: #999;
    p {
      margin-top: 10px;
    }
  }
  .bulletin-item {
    .bulletin-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .bulletin-title {
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
      }
      .bulletin-date {
        margin-left: auto;
        color: #999;
        font-size: 12px;
      }
    }
    .bulletin-content {
      color: #666;
      line-height: 1.6;
      margin-bottom: 8px;
    }
    .bulletin-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .bulletin-author {
        color: #999;
        font-size: 12px;
      }
    }
  }
}
</style>